<template>
  <div class="main-page page-legislative-proposals-home">
    <header class="header_home">
      <div class="c-left">
        <img class="logo " :src="pointConfig.logo" v-if="pointConfig && pointConfig.logo">
        <img src="https://qiniu.laway.cn/yn/2023/05/05/30b4062eeb2a11ed9d4db4055d0b07be.png" class="logo " v-else>
        <img class="logo " v-if="pointConfig && pointConfig.extralogo" :src="pointConfig.extralogo">
        <div class="qr showconsole grayscale">
          <img v-if="$store.state.device.config" :src="$store.state.device.config.web_qr_url" :alt="$store.state.device.config.web_qr_content" width="64" height="64">
          <div>
            <strong>云南掌上12348</strong>
            <p>关注微信公众号<br />获得更多法律服务</p>
          </div>
        </div>

        <div class="qr grayscale" v-if="qrurl">
          <img :src="qrurl" height="64" alt="">
        </div>
        <div class="phone grayscale ">
          <img src="/img/ui/home/phone_green.png" alt="">
          <div>
            <strong>12348</strong>
            <p>拨打电话免费咨询法律问题</p>
          </div>
        </div>
        <div class="performance grayscale">
          <div @click="toLegisPc" class="performance-item">
            <img src="https://qiniu.laway.cn/publaw/69aa7952840311f19d5bfa2800184358.png" style="height:0.7rem" alt="">
          </div>
        </div>
        <div class="performance grayscale">
          <div @click="toLifa" class="performance-item">
            <img src="https://qiniu.laway.cn/yn/2023/05/05/2e2c8a4eeb2911ed9d4db4055d0b07be.png" alt="">
          </div>
        </div>
      </div>
      <div class="c-right grayscale">
        <div class="r-suggest" @click="$router.push('/suggest')">
          <img src="/img/ui/home/suggest.png" alt="建议反馈" class="suggest">
          <span>
            建议反馈
          </span>
        </div>
      </div>
    </header>
    <div class="demo-panel__content grayscale">
      <div class="c-left">
        <div class="video-panel">
          <video controls controlslist="nodownload" id="videopanel" class="video1" poster="/img/banner/bg_video.jpg" webkit-playsinline="true" style="width: 100%; display: block; height:100%;">
            <source :src="currentVideo.video" type="video/mp4">
          </video>
        </div>
        <ul class="c-left_items">
          <li :class="['p-item', 'c' + (index + 1)]" v-for="(items, index) in prolist[0].list" :key="'key-item' + index" @click="toNewUrl(items)">
            <div class="imgs" v-if="items.icon">
              <img :src="items.icon" alt="">
            </div>
            <div class="title">
              {{ items.title }}
            </div>
          </li>
        </ul>
      </div>
      <div class="c-center">
        <!-- 视频咨询 -->
        <section v-for="(items, index) in prolist[1].list" :key="'key-item' + index">
          <div :class="['p-item', 'c' + (index + 1)]" @click="toNewUrl(items)">
            <img :src="items.icon" alt="">
            <div class="title">
              {{ items.title }}
            </div>
          </div>
        </section>
      </div>
      <div class="c-right">
        <div class="s-banner">
          <!-- 广告banner -->
          <HomeSwiper :slidesPerView="1"></HomeSwiper>
        </div>
        <div class="p-box">
          <div :class="['p-item', 'c' + (index + 1)]" v-for="(items, index) in prolist[2].list" :key="'key-item' + index" @click="toNewUrl(items)">

            <img :src="items.icon" alt="">
            <div class="title">
              {{ items.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Rightslide v-model="slide" @getClose="slide.show = false">
      <template slot="content">
        <div class="video-list grayscale">
          <div class="hts">普法视频</div>
          <ul>
            <li v-for="(item, index) in videoList" :key="'key-videolist-' + index" @click="playVideo(item, index)">
              <a href="javascript:;">
                <img :src="item.img[0]" alt>
                <strong class="video-title">{{ item.title }}</strong>
                <!-- <p>{{item.type}} ∙ {{item.view}}次浏览</p> -->
              </a>
            </li>
          </ul>
        </div>
      </template>
      <template slot="footer">
        <div class="btns yel" @click="slide.show = false">
          <button>返回</button>
        </div>
      </template>
    </Rightslide>
    <HomeFoot :showPro="false" />
    <el-dialog title="留言" :visible.sync="showLeaveDialog">
      <p style="margin-bottom: 20px;">当前时间段仅支持留言咨询</p>
      <el-form :model="leaveForm" :rules="leaveRule" label-position="left" ref="leaveFormRef" :disabled="leaveLoading">
        <el-form-item label="联系方式:" prop="leavePhone">
          <el-input @input="verifyPhone" style="width: 300px;" v-model="leaveForm.leavePhone" :maxlength="11" placeholder="请填写联系方式">
          </el-input>
        </el-form-item>
        <el-form-item label="留言内容:" prop="leaveMessage">
          <el-input v-model="leaveForm.leaveMessage" :show-word-limit="true" :autosize="{ minRows: 4, maxRows: 4 }" :maxlength="300" type="textarea" resize="none" placeholder="请填写留言内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="confirmLeave(false)" :loading="leaveLoading">取 消</el-button>
        <el-button type="primary" @click="confirmLeave(true)" :loading="leaveLoading">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Dialogs from '@/components/Dialog.vue'
import Rightslide from '@/components/RightSlide'
import api from '@/datas/js/api'
import { getDeviceRule, confirmLeaveMessage } from '@/lib/request'
import { v4 as generateUUID } from 'uuid'
import HomeSwiper from '@/components/home/HomeSwiper'
import HomeFoot from '@/components/home/HomeFoot'
export default {
  data () {
    return {
      advertisinglist: [],
      slide: {
        show: false
      },
      user: '',
      password: '',
      dialog: {
        show: false,
        title: '',
        type: '',
        cancelBtn: '返回'
      },
      alert: {
        info: '',
        show: false,
        recall: () => { }
      },
      currentVideo: '',
      videoList: [],
      pointConfig: '',
      isflat: false, // 是否是平板
      prolist: {
        0: {
          list: [
            {
              title: '普法视频',
              law: true,
              icon: '/img/ui/videohome/icon_video.png'
            },

            {
              title: '企业法治体检',
              isexam: true,
              icon: '/img/ui/videohome/icon_exam.png'
            },
            {
              title: '法律法规查询',
              path: '/law',
              icon: '/img/ui/videohome/icon_law.png'
            }
          ]
        },
        1: {
          list: [
            {
              title: '实时咨询律师',
              path: '/video',
              icon: '/img/ui/videohome/icon_videozixun.png'
            },

            {
              title: '精准法律咨询',
              origin: 'advisory',
              icon: '/img/ui/videohome/icon_advisory.png',
            },
            {
              title: '留言咨询',
              path: '/service/10',
              icon: '/img/ui/videohome/message.png'
            },
            {
              title: '法律文书模板',
              path: '/service/11',
              icon: '/img/ui/videohome/icon_wenshu.png'
            }
          ]
        },
        2: {
          list: [
            {
              title: '法律援助',
              path: '/service/6',
              icon: '/img/ui/videohome/icon_aid.png'
            },
            {
              title: '人民调解',
              path: '/service/0',
              icon: '/img/ui/videohome/icon_tiaojie.png'
            },
            {
              title: '公证服务',
              path: '/service/2',
              icon: '/img/ui/videohome/icon_gongzheng.png'
            },
            {
              title: '司法鉴定',
              path: '/service/3',
              icon: '/img/ui/videohome/icon_jianding.png'
            },
            {
              title: '仲裁',
              path: '/service/13',
              icon: '/img/ui/videohome/icon_zhongcai.png'
            },
            {
              title: '全部服务',
              path: '/allservice',
              icon: '/img/ui/videohome/icon_allservice.png'
            }
          ]
        },
      },
      showLeaveDialog: false, // 是否显示留言弹窗
      leaveForm: {
        leaveMessage: '', // 留言内容
        leavePhone: '', // 留言电话
      },
      leaveRule: {
        leavePhone: [
          { required: true, message: '请填写联系方式', trigger: 'blur' },
        ],
        leaveMessage: [
          { required: true, message: '请输入留言内容', trigger: 'blur' },
        ]
      },
      leaveLoading: false,
      leaveTimer: null,
      play: null,
      isAutoPlay: false
    }
  },
  computed: {
    technical () {
      const point = this.$store.state.device.point.config && JSON.parse(this.$store.state.device.point.config)
      const config = this.$store.state.device.config.base_config && JSON.parse(this.$store.state.device.config.base_config)
      let title = ''
      try {
        if (point && point.footer) {
          title = point.footer === undefined ? '律品汇科技（北京）有限公司' : point.footer
        } else if (config && config.footer) {
          title = config.footer === undefined ? '律品汇科技（北京）有限公司' : config.footer
        } else if (point && point.footer === '') {
          title = 'hide'
        } else if (config && config.footer === '') {
          title = 'hide'
        } else {
          title = '律品汇科技（北京）有限公司'
        }
        return title
      } catch (error) {
        console.log(error)
        return '律品汇科技（北京）有限公司'
      }
    }
  },
  components: {
    Dialogs,
    Rightslide,
    HomeSwiper,
    HomeFoot
  },
  async created () {
    const StateDevice = this.$store.state.device
    if (!StateDevice.point) {
      await this.$store.dispatch('device/getData')
    }
    if (!StateDevice.point.geography) {
      this.$router.push('/initial')
    }
    const point = StateDevice.point
    this.pointConfig = point && point.config ? JSON.parse(point.config) : ''
    this.qrurl = this.pointConfig && this.pointConfig.qr ? this.pointConfig.qr : ''
    let extconfig = StateDevice.config
    const pointcode = point.code
    extconfig = extconfig && extconfig.extra_config ? JSON.parse(extconfig.extra_config) : ''
    if (extconfig.config) {
      // 获取广告banner
      this.advertisinglist = extconfig.config[pointcode] && extconfig.config[pointcode].banner && extconfig.config[pointcode].banner.length ? extconfig.config[pointcode].banner : extconfig.config['banner']

    }
  },
  watch: {
    play (val) {
      if (val === 1) {
        this.setAutoplay()
      }
      const video = document.querySelector("#videopanel")
      console.log('play:', val, 'isAutoPlay:', this.isAutoPlay, 'video.autoplay:', video.autoplay, 'video.paused', video.paused)
      if (val === 0 && this.isAutoPlay) {
        console.log('自动播放停止')
        this.setAutoplayEnd()
      }
    }
  },
  async mounted () {
    const point = this.$store.state.device.point.config && JSON.parse(this.$store.state.device.point.config)
    await this.getPufaVideo()
    this.currentVideo = this.videoList.length ? Object.assign(this.videoList[0], { index: 0 }) : ''
    // this.setTime()
    document.querySelector('#videopanel').src = this.currentVideo.video
    this.$nextTick(() => {
      //首页视频区域自动播放代码
      if (point && point.isAutoPlay) {
        document.querySelector('#videopanel').autoplay = true
        document.querySelector('#videopanel').play()
        document.querySelector('#waitAudio').src = ''
        document.querySelector('#waitAudio').pause()
      }
      document.querySelector('#videopanel').addEventListener('ended', () => {
        /**
         * 监听到播放结束后
         * 自动切换下一个视频
         * 以下为边界判断
         * 视频列表不能为空，视频只有一条时加上循环播放
         * 视频列表大于1条时，loop整个视频列表
         * currentVideo作为对象进行存储，提供暂停时需要的信息展示
         */
        if (this.videoList.length === 1) {
          document.querySelector('#videopanel').loop = 'loop'
        } else {
          const idx = this.currentVideo.index + 1 === this.videoList.length ? 0 : this.currentVideo.index + 1
          this.currentVideo = Object.assign(this.videoList[idx], { index: idx })
          document.querySelector('#videopanel').src = this.currentVideo.video
          if (point && point.isCycle || this.play === 1) {
            document.querySelector('#videopanel').play()
            const machineId = this.$store.state.device.point.no
            this.$get(`/pufa/post/?post_id=${this.videoList[idx].id}&machine_id=${machineId}&platform=ZD`)
          }
        }
      }, false)
    })
    if (this.$socket) {
      // 监听留言事件,判断是否留言成功
      this.$socket.on('sendMsg', async (data) => {
        if (data.type === 'leaveMessage') {
          const res = await confirmLeaveMessage({ messageUUID: data.uuid, phone: data.attribute.leaveMessage.phone, content: data.attribute.leaveMessage.message })
          if (res) {
            if (this.leaveTimer) {
              clearTimeout(this.leaveTimer)
              this.leaveTimer = null
            }
            this.leaveLoading = false
            this.showLeaveDialog = false
            this.$message.success('留言成功');

          }
        }
      })
    }
  },
  methods: {
    async setTime () {
      const { result } = await this.$get('/pufa/post/play/')
      console.log(result, 'result')
      this.play = result.play || 0
      if (result.play === 1) {
        this.isAutoPlay = true
      }
      setTimeout(() => {
        this.setTime()
      }, 1000 * 60)
    },
    setAutoplay () {
      this.$nextTick(() => {
        document.querySelector('#videopanel').autoplay = true
        if (this.videoList.length) {
          this.playVideo(this.videoList[0], 0)
        }
      })
    },
    setAutoplayEnd () {
      document.querySelector('#videopanel').pause()
      document.querySelector('#videopanel').autoplay = false
      document.querySelector('#waitAudio').src = ''
      document.querySelector('#waitAudio').pause()
      this.isAutoPlay = false
    },
    // 手机号校验
    verifyPhone () {
      if (!/^1[0-9]{10}$/.test(this.leaveForm.leavePhone))
        this.leaveForm.leavePhone = this.leaveForm.leavePhone.replace(/[^\d]/g, '');
    },
    // 留言表单提交
    confirmLeave (bool) {
      if (bool) {
        this.$refs.leaveFormRef.validate((valid) => {
          if (valid) {
            this.leaveLoading = true;
            // 提交留言
            const msg = {
              uuid: generateUUID(),
              content: '',
              attribute: {
                leaveMessage: {
                  phone: this.leaveForm.leavePhone,
                  message: this.leaveForm.leaveMessage
                }
              },
              type: 'leaveMessage',
              roomName: window.roomName,
              sendTime: new Date(),
            };
            this.$socket.emit("sendMsg", msg);
            if (this.leaveTimer) {
              clearTimeout(this.leaveTimer)
              this.leaveTimer = null
            }
            this.leaveTimer = setTimeout(() => {
              if (this.showLeaveDialog && this.leaveLoading) {
                this.$message.error('留言提交等待超时');
                this.leaveLoading = false
              }
            }, 30000)
          }
        })
      } else {
        this.showLeaveDialog = false;
      }
      this.$refs.leaveFormRef.resetFields()
    },
    playVideo (item, index) {
      // play video
      this.slide.show = false
      this.currentVideo = Object.assign(item, { index })
      const machineId = this.$store.state.device.point.no
      this.$get(`/pufa/post/?post_id=${item.id}&machine_id=${machineId}&platform=ZD`)
      this.$nextTick(() => {
        document.querySelector('#videopanel').src = item.video
        document.querySelector('#videopanel').play()
        document.querySelector('#waitAudio').src = ''
        document.querySelector('#waitAudio').pause()
      })
    },
    async toNewUrl (item) {
      if (item && item.law) {
        this.slide.show = true
      }
      if (item && item.origin === 'advisory') {
        this.toAdvisorys()
      }
      if (item && item.path === '/law') {
        this.toLaw()
        return
      }
      if (item && item.path === '/video') {
        // TODO: 请求接口判断是否开启校验规则,增加留言
        try {
          const res = await getDeviceRule(window.localStorage.code)
          if (res && res.open) {
            const time = new Date()
            // if (time.getHours() >= 18 && time.getHours() < 21) { // 下午六点以后九点以前只允许语音咨询

            // } else
            if (time.getHours() >= 21 || time.getHours() < 9) { // 下午九点到次日九点， 只允许留言咨询
              this.showLeaveDialog = true;
            } else {
              this.$router.push(item.path)
            }
          } else {
            this.$router.push(item.path)
          }
        } catch (err) {
          this.$router.push(item.path)
        }
        return
      }
      if (item.iscalc) {
        this.toCalc()
      }
      if (item.isexam) {
        this.toExam()
      }
      if (item && item.path) {
        this.$router.push(item.path)
      }
    },

    async getPufaVideo () {
      const { result, status } = await this.$get(`${api.list}5fd17c657edc0146d49338eb`)
      if (status) {
        this.videoList = result.data.items
      }
    },
    toLifa () {
      this.$router.push(`/iframes?urls=${encodeURIComponent('http://whlf.kmrd.cn:8081/whpf/whpfHome')}&showHead=1`)
    },
    toLegisPc () {

      this.$router.push(`/post/6a608b517edc0109f2f0c4a7`)
    }
  },

}
</script>

<style>
video::-internal-media-controls-download-button {
  display: none;
}

video::-webkit-media-controls-enclosure {
  overflow: hidden;
}

video::-webkit-media-controls-panel {
  width: calc(100% + 30px);
}
</style>

<style lang="stylus" scoped>
.page-legislative-proposals-home
  position relative
  box-sizing border-box
  padding 0.44rem 0 0
  overflow hidden
  .header_home
    display flex
    justify-content space-between
    align-items center
    padding 0.3rem 0.6rem 0
    margin-bottom 0.45rem
    .c-left
      display flex
      align-items center
      color #fff
      .logo
        margin-right 0.3rem
        flex-shrink 0
        height 0.73rem
      .qr
        display flex
        align-items center
        font-size 0.14rem
        img
          margin-right 0.15rem
        strong
          display block
          font-size 0.18rem
          margin-bottom 0.02rem
      .phone
        margin-left 0.2rem
        display flex
        align-items center
        font-size 0.14rem
        img
          width 0.6rem
          margin-right 0.14rem
        strong
          font-size 0.3rem
          font-style italic
      .performance
        margin-left 0.2rem
        a
          display block
    .c-right
      display flex
      align-items center
      color #e3edff
      font-size 0.18rem
      .r-help, .r-suggest
        display flex
        align-items center
      .r-help
        margin-right 0.48rem
      img
        margin-right 0.1rem
        &.help
          width 0.24rem
        &.suggest
          width 0.2rem
  .demo-panel__content
    display flex
    padding 0 0.6rem
    justify-content space-between
    .c-left
      width 8.94rem
      height 5.71rem
      .video-panel
        margin 0
        width 8.93rem
        height 5.71rem
        background-color rgba(0, 0, 0, 0.5)
        margin-bottom 0.15rem
      .c-left_items
        display flex
        justify-content space-between
        .p-item
          width 2.88rem
          height 1.81rem
          color #fff
          font-size 0.24rem
          text-align center
          &.c1
            background-image linear-gradient(-180deg, #505efa 0%, #747ff9 100%)
          &.c2
            background-image linear-gradient(-180deg, #007ae3 0%, #00b0ee 100%)
            .imgs
              img
                width 0.65rem
                margin 0 auto
          &.c3
            background-image linear-gradient(-180deg, #0066e5 0%, #4798fc 100%)
            img
              margin-top 0.05rem
          .imgs
            margin 0.35rem 1.09rem 0.1rem
            width 0.75rem
            height 0.76rem
            img
              max-width 100%
              display block
              margin 0 auto
    .c-center
      width 2.88rem
      .p-item
        color #fff
        font-size 0.24rem
        text-align center
        margin-bottom 0.14rem
        &.c1
          height 1.81rem
          background-image linear-gradient(-180deg, #007ae3 0%, #07abe5 100%)
          img
            margin 0.31rem 0 0.1rem
            width 0.6rem
        &.c2
          height 1.81rem
          background-image linear-gradient(-180deg, #e8822e 0%, #ffaa54 100%)
          img
            margin 0.31rem 0 0
            width 0.77rem
            height 0.9rem
        &.c3
          height 1.81rem
          background-image linear-gradient(-180deg, #505efa 0%, #747ff9 100%)
          img
            margin 0.4rem 0 0.04rem
            width 0.75rem
        &.c4
          height 1.81rem
          background-image linear-gradient(-180deg, #24ad5d 0%, #1ed96c 100%)
          img
            margin 0.36rem 0 0.1rem
            width 0.68rem
            height 0.76rem
    .c-right
      width 5.9rem
      .s-banner
        height 1.81rem
        margin-bottom 0.15rem
        img
          width 100%
      .p-box
        display flex
        justify-content space-between
        flex-wrap wrap
        .p-item
          color #fff
          font-size 0.24rem
          text-align center
          margin-bottom 0.14rem
          width 2.88rem
          height 1.81rem
          &.c1
            background-image linear-gradient(-180deg, #e3464e 0%, #fd767c 100%)
            img
              margin 0.4rem 0 0.1rem
              width 0.77rem
              height 0.7rem
          &.c2
            background-image linear-gradient(-180deg, #8d38d3 0%, #c653f1 100%)
            img
              margin 0.4rem 0 0.1rem
              width 0.99rem
              height 0.69rem
          &.c3
            background-image linear-gradient(-180deg, #007ae3 0%, #07abe5 100%)
            img
              margin 0.4rem 0 0
              width 0.69rem
              height 0.76rem
          &.c4
            background-image linear-gradient(-180deg, #505efa 0%, #747ff9 100%)
            img
              margin 0.4rem 0 0
              width 0.73rem
              height 0.79rem
          &.c5
            background-image linear-gradient(-180deg, #007ae3 0%, #06ace7 100%)
            img
              margin 0.4rem 0 0.08rem
              width 0.74rem
              height 0.73rem
          &.c6
            background-image linear-gradient(-180deg, #e96137 0%, #f88360 100%)
            img
              margin 0.4rem 0 0.15rem
              width 0.63rem
              height 0.65rem
  .video-list
    padding 0.3rem 0 0 0.3rem
    .hts
      font-size 0.36rem
      font-weight bold
    ul
      display flex
      flex-wrap wrap
      padding 0.3rem 0
      li
        width 50%
        margin-bottom 0.3rem
        a
          display block
          margin-right 0.3rem
          color #333
          img
            width 100%
            min-height 2.1rem
            max-height 2.1rem
            border-radius 0.1rem
            overflow hidden
            object-fit cover
            display block
          strong
            padding-top 0.2rem
            font-size 0.24rem
            display -webkit-box
            -webkit-box-orient vertical
            -webkit-line-clamp 1
            overflow hidden
          p
            padding-top 0.1rem
            font-size 0.18rem
            color #666666
.login-input
  font-size 0.26rem
  line-height 1
  height 0.8rem
.input-label
  font-size 0.3rem
  line-height 0.8rem
.login-btns
  color #fff !important
.login-row
  margin-bottom 0.2rem
.setting-btn
  text-decoration none
  color #fff
  margin-left 0.4rem
</style>
